import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  assetDataProviderSortIcon: {
    height: '0.625rem',
    marginLeft: theme.spacing(0.5)
  },
  assetDataProviderTableContainer: {
    height: '100%',
    position: 'relative',
    boxShadow: theme.shadows[2],
    borderRadius: 4,
    backgroundColor: theme.vars.palette.background.elevation2,
    gridRow: 'span 4',
    [theme.breakpoints.down('xl')]: {
      gridColumn: 'span 2',
      gridRow: 'span 1'
    },
    [theme.breakpoints.down('md')]: {
      gridColumn: 'span 1',
      gridRow: 'span 1'
    }
  },
  assetDataProviderNoData: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    color: theme.vars.palette.text.secondary
  },
  assetDataProviderTable: {
    height: '100%'
  },
  assetDataProviderTableHeaderCell: {
    padding: '0.5rem',
    backgroundColor: theme.vars.palette.background.elevation2
  },
  assetDataProviderTablePagination: {
    position: 'sticky',
    zIndex: 29,
    display: 'relative',
    bottom: 0,
    borderTop: `1px solid ${theme.vars.palette.border.light}`,
    borderBottom: 0, // remove weird bottom border when selecting 50 rows
    backgroundColor: theme.vars.palette.background.elevation2
  },
  assetDataProviderTableBodyCell: {
    padding: '0.5rem'
  }
}));

export default useStyles;
